<template>
  <el-row :gutter="15">
    <el-col
      :xs="12"
      :sm="8"
      :md="7"
      :lg="6"
      :xl="4"
    >
      <el-card
        shadow="never"
        header="Invoicing Reports"
      >
        <el-menu
          :default-active="activeList"
          class="border-0"
          @select="index => { activeList = index }"
        >
          <el-menu-item index="InvoiceCarriers">
            <FontAwesomeIcon
              :icon="[ 'fal', 'person-carry' ]"
              size="lg"
            />
            <span class="pl-3">Invoice Carrier</span>
          </el-menu-item>

          <el-menu-item index="ImportedNoteReconciled">
            <FontAwesomeIcon
              :icon="[ 'fal', 'ballot-check' ]"
              size="lg"
            />
            <span class="pl-3">Imported Note Reconciled</span>
          </el-menu-item>

          <el-menu-item index="InvoiceFreight">
            <FontAwesomeIcon
              :icon="[ 'fal', 'file-invoice-dollar' ]"
              size="lg"
            />
            <span class="pl-3">Invoice Freight</span>
          </el-menu-item>

          <el-menu-item index="InvoiceSummary">
            <FontAwesomeIcon
              :icon="[ 'fal', 'file-invoice' ]"
              size="lg"
            />
            <span class="pl-3">Invoice Summary</span>
          </el-menu-item>

          <el-menu-item index="StuckInvoices">
            <FontAwesomeIcon
              :icon="[ 'fal', 'hand-holding-usd' ]"
              size="lg"
            />
            <span class="pl-3">Stuck Invoices</span>
          </el-menu-item>

          <el-menu-item index="UninvoicedReconciled">
            <FontAwesomeIcon
              :icon="[ 'fal', 'money-check-alt' ]"
              size="lg"
            />
            <span class="pl-3">Uninvoiced Reconciled</span>
          </el-menu-item>

          <el-menu-item index="UnInvoiceFreight">
            <FontAwesomeIcon
              :icon="[ 'fal', 'money-check' ]"
              size="lg"
            />
            <span class="pl-3">Uninvoiced Freight</span>
          </el-menu-item>

          <el-menu-item index="MyobExport">
            <FontAwesomeIcon
              :icon="[ 'fal', 'piggy-bank' ]"
              size="lg"
            />
            <span class="pl-3">MYOB Export</span>
          </el-menu-item>

          <el-menu-item index="InvoiceFees">
            <FontAwesomeIcon
              :icon="[ 'fal', 'comment-dollar' ]"
              size="lg"
            />
            <span class="pl-3">Invoice Fees</span>
          </el-menu-item>

          <el-menu-item index="InvoiceStatus">
            <FontAwesomeIcon
              :icon="[ 'fal', 'money-bill-alt' ]"
              size="lg"
            />
            <span class="pl-3">Invoice Status</span>
          </el-menu-item>

          <el-menu-item index="FuelReport">
            <FontAwesomeIcon
              :icon="[ 'fal', 'shower' ]"
              size="lg"
            />
            <span class="pl-3">Fuel Report</span>
          </el-menu-item>

          <el-menu-item index="UprateReport">
            <FontAwesomeIcon
              :icon="[ 'fal', 'file-invoice-dollar' ]"
              size="lg"
            />
            <span class="pl-3">Uprate Report</span>
          </el-menu-item>
        </el-menu>
      </el-card>
    </el-col>

    <el-col
      :xs="12"
      :sm="16"
      :md="17"
      :lg="18"
      :xl="20"
    >
      <el-card shadow="never">
        <template #header>
          <span>{{ `${$filters.titleize(activeList)} Report` }}</span>
        </template>
        <component
          :is="activeList"
          ref="list"
        />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import InvoiceCarriers from '@/components/Application/Reports/Invoice/Carrier'
import ImportedNoteReconciled from '@/components/Application/Reports/Invoice/ImportedNoteReconciled'
import InvoiceFreight from '@/components/Application/Reports/Invoice/InvoiceFreight'
import InvoiceSummary from '@/components/Application/Reports/Invoice/InvoiceSummary'
import StuckInvoices from '@/components/Application/Reports/Invoice/StuckInvoices'
import UninvoicedReconciled from '@/components/Application/Reports/Invoice/UninvoicedReconciled'
import UnInvoiceFreight from '@/components/Application/Reports/Invoice/UnInvoiceFreight'
import MyobExport from '@/components/Application/Reports/Invoice/MyobExport'
import InvoiceFees from '@/components/Application/Reports/Invoice/InvoiceFees'
import InvoiceStatus from '@/components/Application/Reports/Invoice/InvoiceStatus'
import FuelReport from '@/components/Application/Reports/Invoice/FuelReport'
import UprateReport from '@/components/Application/Reports/Invoice/UprateReport'

export default {
  components: {
    InvoiceCarriers,
    ImportedNoteReconciled,
    InvoiceFreight,
    InvoiceSummary,
    StuckInvoices,
    UninvoicedReconciled,
    UnInvoiceFreight,
    MyobExport,
    InvoiceFees,
    InvoiceStatus,
    FuelReport,
    UprateReport
  },
  data () {
    return {
      title: 'Invoicing Reports',
      breadcrumb: {
        name: 'Invoicing Reports',
        route: { name: 'reports-invoice' }
      },
      activeList: 'InvoiceCarriers'
    }
  }
}
</script>
